import { getAccount, getChainId, } from "wagmi/actions";
import { wagmiConfig, } from "@config";
import { tokenExists, } from "@bracket/addressbook";


export const assertStaked = async ( ) => {
	
	const { address, } = getAccount(wagmiConfig);
	
}

/**
 * 
 */
export const getDefaultTokens = ( ): [ string, string, string, ] => {

	const { search, } = window.location;
	const parts = search.length ? search.slice(1,search.length).split("&").map(str => str.split("=")) : [];
	const chain = getChainId(wagmiConfig);
	const swapping = parts.find(part => part[0] === "asset_swap" && part[1] === "true");
	const asset = parts.find(part => part[0] === "asset");

	const depositLabel = !swapping && asset ? asset[1] : "ETH";
	const swapDepositLabel = swapping && asset ? asset[1] : "wstETH";
	const swapWithdrawalLabel = "ETH";

	if(chain === 1 || chain === 18 ) {

		return [
			tokenExists(depositLabel, chain) ? depositLabel : "ETH",
			tokenExists(swapDepositLabel, chain) ? swapDepositLabel : "wstETH",
			tokenExists(swapWithdrawalLabel, chain) ? swapWithdrawalLabel : "ETH",
		];

	}
	return [ "ETH", "wstETH", "ETH" ];
}


export const makeCancellablePromise = <T>(promise: Promise<T>): [ Promise<T>, () => void ] => {

	let isCancelled = false;

	const wrappedPromise: typeof promise = new Promise((resolve, reject) => {
		promise
			.then((value) => !isCancelled && resolve(value))
			.catch((error) => !isCancelled && reject(error));
	});

	return [
		wrappedPromise,
		() => { isCancelled = true; }
	];

}
